import { Component } from '@angular/core';
import { soundpostReconRunIntegrationEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';

@RegisterClass(BaseFormComponent, 'Recon Run Integrations') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-soundpostreconrunintegration-form',
    templateUrl: './soundpostreconrunintegration.form.component.html'
})
export class soundpostReconRunIntegrationFormComponent extends BaseFormComponent {
    public record!: soundpostReconRunIntegrationEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true }
        ]);
    }
}

